import React from "react";
import { Link } from "react-router-dom";
import { useCollection } from "../useData";
import { resolveImg } from "../api";
import SEO from "../components/SEO";

const Commercial = () => {
  const commercial = useCollection("commercial") || [];
  return (
    <div className="px-6 md:px-10 max-w-[1100px] mx-auto">
      <SEO
        title="Commercial"
        description="Selected commissioned work — editorial, portrait, fashion and campaign photography by Alice Lisi. Clients include Vogue, L'Officiel, Disney, Loro Piana, Moncler and Mytheresa."
        path="/commercial"
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-16 pb-8">
        {commercial.map((c, i) => (
          <Link to={`/commercial/${c.id}`} key={c.id} className="tile group">
            <div className="aspect-square bg-[color:var(--paper-2)] overflow-hidden">
              {c.cover ? (
                <img src={resolveImg(c.cover)} alt={c.title} loading="lazy" decoding="async" className="tile-img w-full h-full object-cover" />
              ) : null}
            </div>
            <div className="mt-4">
              <p className="font-serif italic text-xl leading-tight">{c.client}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Commercial;
